import ResultListByExamCardId from './ResultListByExamCardId';

export default ResultListByExamCardId;
